import { PaymentStateModel } from './models';

export const getPaymentState = (state: PaymentStateModel) => {
  return state.paymentStatus;
};
